import { apiUrl } from './config';

function explainError(payload, fallback) {
  if (payload?.details) return `資料驗證未通過：${JSON.stringify(payload.details).slice(0, 350)}`;
  if (typeof payload?.error === 'string') return payload.error;
  if (typeof payload?.detail === 'string') return payload.detail;
  return fallback;
}

async function ledgerRequest({ authToken, data, expectedRevision }) {
  if (!authToken) return { success: false, error: '請先登入再使用個人帳本。' };
  const saving = data !== undefined;
  try {
    const response = await fetch(`${apiUrl}/finance-ledger/`, {
      method: saving ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
      ...(saving ? { body: JSON.stringify({ expected_revision: expectedRevision, data }) } : {}),
    });
    const payload = await response.json().catch(() => null);
    if (!response.ok) return {
      success: false,
      conflict: response.status === 409,
      error: response.status === 409
        ? '帳本已在另一個分頁或裝置更新。請先下載目前草稿備份，再重新讀取最新資料。'
        : explainError(payload, saving ? '儲存失敗，請稍後重試。' : '無法讀取個人帳本，請稍後重試。'),
    };
    if (!payload?.data || !Array.isArray(payload.data.accounts) || !Array.isArray(payload.data.transactions) || !Array.isArray(payload.data.budgets) || !Array.isArray(payload.data.import_batches) || !Number.isSafeInteger(payload.revision) || payload.revision < 0) {
      return { success: false, error: '帳本回應格式不完整，請重新讀取。' };
    }
    return { success: true, data: payload.data, revision: payload.revision };
  } catch {
    return { success: false, error: '暫時無法連線，請確認帳本服務已啟動後再試。' };
  }
}

export const fetchFinanceLedger = ({ authToken }) => ledgerRequest({ authToken });
export const saveFinanceLedger = ({ authToken, data, expectedRevision }) => ledgerRequest({ authToken, data, expectedRevision });
